import * as React from "react";
import { connect } from "react-redux";
import { bindActionCreators, Dispatch } from "redux";
import { StoreModel } from "models/StoreModel";
import { LoginUserActions } from "redux/actions/LoginUserActions";
import { PageContentHeader } from "app/components/common/PageContentHeader";
import Translator from "app/components/common/Translator";
import { buttonTypes, CstmBtn } from "app/components/common/Button";

interface Props {
    moveHome: typeof LoginUserActions.moveToHome;
}

class RegisterSuccessComp extends React.Component<Props> {
    render() {
        return (
            <div className="c-page__content">
                <PageContentHeader text="Welcome to MOPS" />
                <div className="c-card">
                    <Translator text="Your Email has been confirmed!" />
                    <CstmBtn onClick={() => this.props.moveHome()} text={"Continue"} buttonType={buttonTypes.default} addClass="c-button--primary" />
                </div>
            </div>
        )
    }
}

function mapStateToProps(_state: StoreModel) {
    return {
    };
}
function mapDispatchToProps(dispatch: Dispatch) {
    return {
        moveHome: bindActionCreators(LoginUserActions.moveToHome, dispatch),
    };
}
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(RegisterSuccessComp);